import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCYPAoaDj80Cax17-Jd2hRMATFoifMIo8s',
    libraries: 'places',
  },
})
